import { useEffect } from 'react';

import { ErrorTracking } from '@common/errorTracking';

import { useAbTestStore } from '../state/abTestStore';

/**
 * Hook to initialize A/B tests from storage and API
 *
 * This hook:
 * 1. Waits for Zustand store to hydrate from localStorage
 * 2. Fetches active assigned tests from the server API
 * 3. Updates the Zustand store with all assignments
 * 4. Stores assigned tests in Zustand with persist middleware
 */
export const useInitializeAbTests = (): void => {
  const { isHydrated, setAbTests } = useAbTestStore();

  // Initialize A/B tests on component mount and after hydration
  useEffect(() => {
    // Only initialize if store has hydrated
    if (isHydrated) {
      const initializeAbTests = async () => {
        try {
          await setAbTests();
        } catch (error) {
          ErrorTracking.track(error);
        }
      };

      initializeAbTests();
    }
  }, [setAbTests, isHydrated]);
};
